import { RouteHttpVerb } from "@devowl-wp/utils";
const locationRestRevisionCurrentPut = {
    path: "/revision/current",
    method: RouteHttpVerb.PUT
};
export { locationRestRevisionCurrentPut };
